module.exports = __webpack_public_path__ + "static/media/adsidebar.530c7199.jpg";